// extracted by mini-css-extract-plugin
export default {"recblock":"style_recblock_recblock__MJ1sf","titleblock":"style_recblock_titleblock__t465r","cardblock":"style_recblock_cardblock__9SjJ8"};